import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import ChevronDownDark from 'stash/assets/global/chevron-down-dark.svg';
import { Text, Collapse } from '@stashinvest/ui';

const InfoToggleContainer = styled.div`
	padding: ${({ noPadding }) => (noPadding ? '0' : '1em 0')};
`;

const InfoToggleLink = styled.a`
	font-size: ${({ fontSize }) => fontSize || '1rem'};
	font-weight: ${({ fontWeight }) => fontWeight || 'normal'};
	color: ${({ color, theme }) => color || theme.colors.iconDefault};
	text-decoration: none;
	cursor: pointer;
	display: inline-block;

	&:hover {
		text-decoration: none;
	}

	&:after {
		content: '';
		position: absolute;
		width: 2em;
		height: 1.5em;
		color: ${({ color, theme }) => color || theme.colors.iconDefault};
		background: url(${ChevronDownDark}) center center no-repeat;
		background-size: 0.875em;
		transition: transform 0.25s ease-out;
		transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : null)};
	}
`;

const InfoToggleContent = styled.div`
	font-size: ${({ fontSize }) => fontSize || '1rem'};
	padding-top: 1em;
`;

class InfoToggle extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
		};

		this.toggle = this.toggle.bind(this);
	}

	toggle(e, disabled) {
		e.preventDefault();
		!disabled && this.setState({ isOpen: !this.state.isOpen });
	}

	render() {
		const { isOpen } = this.state;
		const {
			align,
			children,
			disabled,
			noPadding,
			marginLeft,
			toggleText,
			fontSize,
			fontWeight,
			color,
			infoToggleEvent,
		} = this.props;

		return (
			<InfoToggleContainer noPadding={noPadding}>
				<Text align={align ? align : 'center'} mb="s">
					<InfoToggleLink
						color={color}
						href="#toggle"
						fontSize={fontSize}
						fontWeight={fontWeight}
						isOpen={isOpen}
						marginLeft={marginLeft}
						onClick={(e) => {
							if (infoToggleEvent) infoToggleEvent();
							this.toggle(e, disabled);
						}}
					>
						{toggleText}
					</InfoToggleLink>
				</Text>
				<Collapse isOpened={isOpen}>
					<InfoToggleContent fontSize={fontSize}>{children}</InfoToggleContent>
				</Collapse>
			</InfoToggleContainer>
		);
	}
}

InfoToggle.propTypes = {
	align: PropTypes.string,
	children: PropTypes.node,
	noPadding: PropTypes.bool,
	toggleText: PropTypes.string,
	fontSize: PropTypes.string,
	disabled: PropTypes.bool,
	marginLeft: PropTypes.string,
	fontWeight: PropTypes.string,
	color: PropTypes.string,
	infoToggleEvent: PropTypes.string,
};

export default InfoToggle;
